export default function useIsProductionApp() {
  const config = useRuntimeConfig();

  return config.public.appEnv === "production";
}
